// §2.6 Tag: panel + hairline. Client, format, track.
export default function Tag({ children, title }) {
  return <span className="ui ui-tag" title={title || (typeof children === 'string' ? children : undefined)}>{children}</span>;
}
